import Icon from 'components/Icon';
import type { FieldKey } from 'hooks';
import type { IconLinkField } from 'models/sitecore';
import type { TemplateString } from 'types';
import { cn } from 'utils/classNames';
import { formatTemplate } from 'utils/format';

import { flattenIconLinks } from './helpers';

interface Props {
	className?: string;
	followUsLabel: TemplateString | FieldKey;
	links: IconLinkField[];
}

export default function PageFooterSocial({
	className,
	followUsLabel,
	links,
}: Props) {
	const items = flattenIconLinks(links);

	if (items.length === 0) {
		return null;
	}

	// Pull margins to visually align the edge with the icons.
	return (
		<ul className={cn('-mx-3 flex', className)}>
			{items.map((item) => (
				<li key={`${item.href}-${item.text}`}>
					<a
						href={item.href}
						target={item.target}
						className="inline-flex size-12 items-center justify-center rounded-full hover:bg-negative/20 hover:forced-colors-outline"
					>
						<Icon name={item.iconName} />
						<span className="sr-only">
							{formatTemplate(followUsLabel, { serviceName: item.text })}
						</span>
					</a>
				</li>
			))}
		</ul>
	);
}
PageFooterSocial.displayName = 'PageFooterSocial';
